(() => {
  "use strict";

  // ===============================
  // FORMAT MONEY FUNCTION
  // ===============================
  function formatMoney(amount, formatString) {
    if (typeof amount === "string") amount = amount.replace(".", "");
    const template = formatString || "${{amount}}";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function moneyFormatter(amount, decimals = 2, thousandsSep = ",", decimalSep = ".") {
      if (isNaN(amount) || amount == null) return 0;
      amount = (amount / 100).toFixed(decimals);
      const parts = amount.split(".");
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousandsSep);
      return parts[1] ? parts[0] + decimalSep + parts[1] : parts[0];
    }

    const type = template.match(placeholderRegex)[1];
    switch (type) {
      case "amount":
        return template.replace(placeholderRegex, moneyFormatter(amount, 2));
      case "amount_no_decimals":
        return template.replace(placeholderRegex, moneyFormatter(amount, 0));
      case "amount_with_comma_separator":
        return template.replace(placeholderRegex, moneyFormatter(amount, 2, ".", ","));
      case "amount_no_decimals_with_comma_separator":
        return template.replace(placeholderRegex, moneyFormatter(amount, 0, ".", ","));
      case "amount_with_apostrophe_separator":
        return template.replace(placeholderRegex, moneyFormatter(amount, 2, "'", "."));
      default:
        return template.replace(placeholderRegex, amount);
    }
  }

  window.formatMoney = formatMoney;

  // ===============================
  // SMOOTH ZOOM LOGIC
  // ===============================
  function initializeZoom(selector, options = {}) {
    const images = document.querySelectorAll(selector);
    const originalizer = options.originalizer || (src => src);
    const backgroundOption = options.background || "#121212";

    function updateScreenSize() {
      const doc = document.documentElement;
      window.zoomScreenWidth = window.innerWidth || doc.clientWidth;
      window.zoomScreenHeight = window.innerHeight || doc.clientHeight;
      window.zoomScrollBarWidth = window.zoomScreenWidth - doc.offsetWidth;
    }

    function closeZoom(overlay, zoomImg, originalImg) {
      overlay.remove();
      zoomImg.remove();
      originalImg.classList.remove("zoom-original--hidden");
    }

    function zoomImage(img) {
      const rect = img.getBoundingClientRect();
      const overlay = document.createElement("div");
      overlay.className = "zoom-bg";
      overlay.style.background = backgroundOption;

      const zoomImg = document.createElement("img");
      zoomImg.className = "zoom-img";
      zoomImg.src = originalizer(img.src);
      zoomImg.width = rect.width;
      zoomImg.height = rect.height;
      zoomImg.style.top = rect.top + window.scrollY + "px";
      zoomImg.style.left = rect.left + "px";

      [overlay, zoomImg].forEach(el =>
        el.addEventListener("click", () => closeZoom(overlay, zoomImg, img), { once: true })
      );

      window.addEventListener("scroll", () => closeZoom(overlay, zoomImg, img), { once: true, passive: true });
      window.addEventListener("resize", () => closeZoom(overlay, zoomImg, img), { once: true, passive: true });

      document.body.appendChild(overlay);
      document.body.appendChild(zoomImg);
      img.classList.add("zoom-original--hidden");
      requestAnimationFrame(() => overlay.classList.add("zoom-bg--reveal"));
    }

    images.forEach(img => {
      if (img.tagName === "IMG") img.addEventListener("click", e => zoomImage(e.currentTarget));
      else {
        const childImg = img.querySelector("img");
        if (childImg) childImg.addEventListener("click", e => zoomImage(e.currentTarget));
      }
    });

    updateScreenSize();
    window.addEventListener("resize", updateScreenSize, { passive: true });
  }

  initializeZoom(".zoomable");

  // ===============================
  // PRODUCT VARIANTS LOGIC
  // ===============================
  const productVariantsContainer = document.querySelector("#product-variants");
  const addToCartButton = document.querySelector('.product-info form[action="/cart/add"] button[type="submit"]');
  const cartFormIdInput = document.querySelector('.product-info form[action="/cart/add"] input[name="id"]');

  if (productVariantsContainer) {
    const variantRadios = productVariantsContainer.querySelectorAll('input[type="radio"]');
    const fieldsets = productVariantsContainer.querySelectorAll("fieldset");

    const getVariantsData = () => JSON.parse(productVariantsContainer.querySelector('[type="application/json"]').textContent);

    function updateVariantLabel(radio) {
      const fieldset = radio.closest("fieldset");
      const label = fieldset.querySelector("legend").dataset.fieldsetLabel;
      fieldset.querySelector("legend span").innerHTML = `${label}: <span class="uppercase font-bold">${radio.value}</span>`;
    }

    function updateAddToCartButton(available) {
      addToCartButton.classList.toggle("btn-disabled", !available);
      addToCartButton.classList.toggle("btn-primary", available);
      addToCartButton.innerHTML = available ? window.product.addToCart : window.product.soldOut;
      addToCartButton.disabled = !available;
    }

    function updatePriceDisplay(variantId) {
      const variant = getVariantsData().find(v => v.id === variantId);
      const vat_rate = document.querySelector('.product-info').dataset.vatrate; 
    
      if (!variant) return;

      const priceIncVAT = document.querySelector(".js-product-price.js-inc-vat");
      const priceExVAT = document.querySelector(".js-product-price.js-ex-vat");
      const compareIncVAT = document.querySelector(".js-product-compare-at-price.js-inc-vat");
      const compareExVAT = document.querySelector(".js-product-compare-at-price.js-ex-vat");
      
      if (priceIncVAT) priceIncVAT.innerHTML = formatMoney(variant.price, window.theme.moneyFormat).replace(".00","");
      // if (priceExVAT) priceExVAT.innerHTML = formatMoney(variant.ex_vat_price, window.theme.moneyFormat).replace(".00","");
      if (priceExVAT) priceExVAT.innerHTML = formatMoney((variant.price / vat_rate), window.theme.moneyFormat).replace(".00","");
      if (variant.compare_at_price) {
        if (compareIncVAT) compareIncVAT.innerHTML = formatMoney(variant.compare_at_price, window.theme.moneyFormat).replace(".00","");
        if (compareExVAT) compareExVAT.innerHTML = formatMoney(variant.compare_ex_vat_price, window.theme.moneyFormat).replace(".00","");
      }
    }
    
    setInterval(()=>{
        const vat_rate = document.querySelector('.product-info').dataset.vatrate; 
        let priceStr = document.querySelector(".js-product-price.js-inc-vat").innerHTML;
        let cleanStr = priceStr.replace(/[^0-9.]/g, "");
        let priceInt = Math.round(parseFloat(cleanStr / vat_rate) * 100);
        document.querySelector(".js-product-price.js-ex-vat").innerHTML = formatMoney(priceInt, window.theme.moneyFormat).replace(".00","");
    },1000); 

    function selectVariant(variant) {
      cartFormIdInput.value = variant.id;
      updatePriceDisplay(variant.id);
      updateAddToCartButton(variant.available);
      const quoteBtn = document.querySelector('.cc-add-to-quote');
      if (quoteBtn) {
        quoteBtn.dataset.productPrice = variant.price;
      }
      const baseUrl = window.location.href.split("?")[0];
      history.pushState(null, null, `${baseUrl}?variant=${variant.id}`);
    }

    function updateUnavailableVariants(selectedRadios) {
      const selectedValues = Array.from(selectedRadios).map(r => r.value);
      const variants = getVariantsData();

      fieldsets.forEach((fieldset, index) => {
        variants.forEach(variant => {
          const value = variant[`option${index + 1}`];
          const labelEl = fieldset.querySelector(`.js-variant-label[data-label-value="${value}"]`);
          if (!labelEl) return;

          const unavailable = selectedValues[index] && value !== selectedValues[index] && !variant.available;
          labelEl.classList.toggle("js-unavailable-variant", unavailable);
        });
      });
    }

    variantRadios.forEach(radio => {
      radio.addEventListener("change", () => {
        const checkedRadios = productVariantsContainer.querySelectorAll('input[type="radio"]:checked');
        const variantTitle = Array.from(checkedRadios).map(r => r.value).join(" / ");
        const selectedVariant = getVariantsData().find(v => v.title === variantTitle);
        console.log(checkedRadios, "checkedRadios", variantTitle, "variantTitle", selectedVariant, "selectedVariant")
        if (selectedVariant) {
          selectVariant(selectedVariant);
          updateVariantLabel(radio);
          updateUnavailableVariants(checkedRadios);
        }
        setTimeout(() => {
          if (typeof BOLD !== 'undefined'
            && typeof BOLD.common !== 'undefined'
              && BOLD.common.eventEmitter !== 'undefined'){
            BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: selectedVariant });
          }
        }, 100)
      });
    });

    if (document.querySelector(".single-variant")) updateAddToCartButton(true);
  }

  // ===============================
  // QUANTITY LOGIC
  // ===============================
  function updateQuantityPrices() {
    
    document.querySelectorAll(".js-prod-btn-group").forEach(group => {
        const unitPrice = parseInt(group.dataset.cvPrice);
        const quantity = parseInt(group.querySelector(".js-input-quantity").value);
        const totalPriceEl = group.querySelector(".js-total-price");
      if (totalPriceEl) totalPriceEl.innerHTML = formatMoney(unitPrice * quantity, window.theme.moneyFormat).replace(".00","");
  
    });
  
  }

  document.querySelectorAll(".js-btn-quantity").forEach(btn => btn.addEventListener("click", updateQuantityPrices));

  // ===============================
  // PRODUCT IMAGES & LOAD MORE
  // ===============================
  const productImagesContainer = document.querySelector(".product-images-container");
  const productImages = productImagesContainer ? Array.from(productImagesContainer.querySelectorAll(".product-image")) : [];
  const loadMoreButton = document.querySelector(".js-load-more");
  const imagesInitiallyShown = parseInt(document.querySelector(".images-shown").value);
  const imagesToShow = parseInt(document.querySelector(".images-toshow").value);
  const hiddenClass = "lg:hidden";

  productImages.splice(0, imagesInitiallyShown).forEach(img => img.classList.remove(hiddenClass));

  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", e => {
      e.preventDefault();
      productImages.splice(0, imagesToShow).forEach(img => img.classList.remove(hiddenClass));
      if (productImages.length === 0) loadMoreButton.classList.add(hiddenClass);
    });
  }

  // ===============================
  // COLOR & SIZE SWATCH AJAX LOGIC
  // ===============================
  function loadSwatches(type) {
    const container = document.querySelector(`.product-${type}-container`);
    if (!container) return;

    const group = container.dataset[`${type}Group`];
    const currentId = parseInt(container.dataset.currentProductId);
    if (!group) return;

    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          const data = JSON.parse(xhr.responseText);
          buildSwatches(type, data, currentId);
        } catch (err) {
          console.error(err);
        }
      }
    };
    xhr.open("GET", `/collections/all/${group}?view=swatch`, true);
    xhr.send();
  }

  function buildSwatches(type, data, currentProductId) {
    const container = document.querySelector(`.product-${type}-container`);
    if (!container) return;

    let html = `<div class="product-${type}s flex flex-wrap cc-gap-x-[30px] cc-gap-y-[10px]">`;
    const products = Object.values(data.products);
    const uniqueItems = [];

    products.forEach(product => {
      if (!uniqueItems.find(u => u[type] === product[type])) uniqueItems.push({ value: product[type], url: product.url, available: product.available });
    });

    uniqueItems.forEach(item => {
      const isCurrent = item.id === currentProductId ? " current" : "";
      html += `<p class="cc-flex cc-items-center cc-gap-[5px]">
        <a href="${item.url}" class="btn-${type}-swatch cc-size-6 rounded-full border border-gray-100 cursor-pointer${isCurrent}" data-product-available="${item.available}" data-product-${type}="${item.value}" aria-label="View product in ${item.value}" tabindex="0"></a>
        <span class="cc-capitalize cc-text-[17px]">${item.value}</span>
      </p>`;
    });

    html += "</div>";
    container.querySelector(".title").insertAdjacentHTML("afterend", html);
  }

  loadSwatches("colour");
  loadSwatches("size");

  // ===============================
  // “Need More?” ENQUIRY ROW
  // ===============================
  setTimeout(() => {
    document.querySelectorAll(".adp-vol-wrapper").forEach(wrapper => {
      const tr = document.createElement("tr");
      const div = document.createElement("div");
      div.textContent = "Need more?";
      div.className = "cc-h-full py-2.5 px-4 flex flex-col cc-text-center w-full cc-text-[13px] cc-font-medium text-primary items-center justify-center gap-2";

      const a = document.createElement("a");
      a.href = "https://displaysense.customerdesk.io/#rp-customer-widget-faq-c383772e-0424-4b62-82d3-7949e8f366b1";
      a.textContent = "Enquire Now";
      a.className = "cc-text-[#759C98] transition duration-300 ease-in-out hover:text-primary cc-underline";

      div.appendChild(a);
      tr.appendChild(div);
      wrapper.querySelector(".adp-discount-table tbody").appendChild(tr);
    });
  }, 1000);



window.addEventListener('load', function() {
   document.querySelectorAll(".product-info form .variant-radio input").forEach(function(input, index){
      if(index == 0){
        const selectedVariant = getVariantsData().find(v => v.title === input.value);
         if (selectedVariant) {
                  selectVariant(selectedVariant);
                  updateVariantLabel(input);
                  updateUnavailableVariants(input);
               }
              setTimeout(() => {
               if (typeof BOLD !== 'undefined'
                 && typeof BOLD.common !== 'undefined'
                   && BOLD.common.eventEmitter !== 'undefined'){
                 BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: selectedVariant });
               }
           }, 100)
      }
   });
});  

document.querySelector('.product-info  .quantity-selector .js-input-quantity').addEventListener('input', function(val){
    let input_val = parseInt(val.target.value);
     document.querySelectorAll(".product-info form .variant-radio input").forEach(function(input, index){
        const min_val = parseInt(input.getAttribute("min"), 10) || 0;
        const max_val = parseInt(input.getAttribute("max"), 10) || Infinity;
        if (input_val >= min_val && input_val <= max_val) {
          const selectedVariant = getVariantsData().find(v => v.title === input.value);

            if (selectedVariant) {
                 selectVariant(selectedVariant);
                 updateVariantLabel(input);
                 updateUnavailableVariants(input);
              }
             setTimeout(() => {
              if (typeof BOLD !== 'undefined'
                && typeof BOLD.common !== 'undefined'
                  && BOLD.common.eventEmitter !== 'undefined'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: selectedVariant });
              }
            }, 100)
        }else if(input_val >= min_val && input_val >= max_val){
          if(index == document.querySelectorAll(".product-info form .variant-radio input").length){
               const selectedVariant = getVariantsData().find(v => v.title === input.value);
               
                if (selectedVariant) {
                    selectVariant(selectedVariant);
                    updateVariantLabel(input);
                    updateUnavailableVariants(input);
                  }
                setTimeout(() => {
                  if (typeof BOLD !== 'undefined'
                    && typeof BOLD.common !== 'undefined'
                      && BOLD.common.eventEmitter !== 'undefined'){
                    BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: selectedVariant });
                  }
                 }, 100) 
          }
        }
       }); 
})


document.querySelectorAll(".quantity-selector .js-btn-quantity").forEach(btn => btn.addEventListener("click", function(){
    setTimeout(function(){
       console.log(btn.closest('.quantity-selector').querySelector('input').value, "quantity")
       let input_value = parseInt(btn.closest('.quantity-selector').querySelector('input').value)
       document.querySelectorAll(".product-info form .variant-radio input").forEach(function(input){
        const min_val = parseInt(input.getAttribute("min"), 10) || 0;
        const max_val = parseInt(input.getAttribute("max"), 10) || Infinity;

        if (input_value >= min_val && input_value <= max_val) {
          const selectedVariant = getVariantsData().find(v => v.title === input.value);

            if (selectedVariant) {
                 selectVariant(selectedVariant);
                 updateVariantLabel(input);
                 updateUnavailableVariants(input);
              }
             setTimeout(() => {
              if (typeof BOLD !== 'undefined'
                && typeof BOLD.common !== 'undefined'
                  && BOLD.common.eventEmitter !== 'undefined'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: selectedVariant });
              }
            }, 100)
        }
       }); 
    }, 500)
 }));

    const getVariantsData = () => JSON.parse(productVariantsContainer.querySelector('[type="application/json"]').textContent);


    function selectVariant(variant) {
      
      // console.log(variant.id, "variant.id", cartFormIdInput.value, "cartFormIdInput")
      cartFormIdInput.value = variant.id;
      updatePriceDisplay(variant.id);
      updateAddToCartButton(variant.available);
      const baseUrl = window.location.href.split("?")[0];
      history.pushState(null, null, `${baseUrl}?variant=${variant.id}`);
    }


    function updatePriceDisplay(variantId) {
      const variant = getVariantsData().find(v => v.id === variantId);
      const vat_rate = document.querySelector('.product-info').dataset.vatrate; 
    
      if (!variant) return;

      const priceIncVAT = document.querySelector(".js-product-price.js-inc-vat");
      const priceExVAT = document.querySelector(".js-product-price.js-ex-vat");
      const compareIncVAT = document.querySelector(".js-product-compare-at-price.js-inc-vat");
      const compareExVAT = document.querySelector(".js-product-compare-at-price.js-ex-vat");
      
      if (priceIncVAT) priceIncVAT.innerHTML = formatMoney(variant.price, window.theme.moneyFormat).replace(".00","");
      if (priceExVAT) priceExVAT.innerHTML = formatMoney((variant.price / vat_rate), window.theme.moneyFormat).replace(".00","");
      if (variant.compare_at_price) {
        if (compareIncVAT) compareIncVAT.innerHTML = formatMoney(variant.compare_at_price, window.theme.moneyFormat).replace(".00","");
        if (compareExVAT) compareExVAT.innerHTML = formatMoney(variant.compare_ex_vat_price, window.theme.moneyFormat).replace(".00","");
      }
    }



    function updateAddToCartButton(available) {
      addToCartButton.classList.toggle("btn-disabled", !available);
      addToCartButton.classList.toggle("btn-primary", available);
      addToCartButton.innerHTML = available ? window.product.addToCart : window.product.soldOut;
      addToCartButton.disabled = !available;
    }


    
     function updateVariantLabel(radio) {
      const fieldset = radio.closest("fieldset");
      const label = fieldset.querySelector("legend").dataset.fieldsetLabel;
      fieldset.querySelector("legend span").innerHTML = `${label}: <span class="uppercase font-bold">${radio.value}</span>`;
    }

    function updateUnavailableVariants(selectedRadios) {
      const selectedValues = Array.from(selectedRadios).map(r => r.value);
      const variants = getVariantsData();
      const fieldsets = productVariantsContainer.querySelectorAll("fieldset");
      fieldsets.forEach((fieldset, index) => {
        variants.forEach(variant => {
          const value = variant[`option${index + 1}`];
          const labelEl = fieldset.querySelector(`.js-variant-label[data-label-value="${value}"]`);
          if (!labelEl) return;

          const unavailable = selectedValues[index] && value !== selectedValues[index] && !variant.available;
          labelEl.classList.toggle("js-unavailable-variant", unavailable);
        });
      });
    }

})();

